import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';

// Ana sayfa: eager load (ilk açılış performansı)
import Homepage from './pages/Home/HomePage';

// Diğer sayfalar: lazy load (code splitting)
const KurumsalMain = lazy(() => import('./pages/Corporate/KurumsalMain'));
const Kurumsal = lazy(() => import('./pages/Corporate/Kurumsal'));
const Hedefler = lazy(() => import('./pages/Corporate/Hedefler'));
const KalitePolitikasi = lazy(() => import('./pages/Corporate/KalitePolitikasi'));
const Tarihce = lazy(() => import('./pages/Corporate/Tarihce'));
const Etik = lazy(() => import('./pages/Corporate/Etik'));
const TanitimFilmi = lazy(() => import('./pages/Corporate/TanitimFilmi'));
const Belgeler = lazy(() => import('./pages/Corporate/Belgeler'));
const KurumsalK = lazy(() => import('./pages/Corporate/KurumsalKimlik'));
const InsanKaynaklari = lazy(() => import('./pages/Other/InsanKaynaklari'));
const Iletisim = lazy(() => import('./pages/Other/Iletisim'));
const OnlineMain = lazy(() => import('./pages/Online/OnlineMain'));
const OnlineSozlesmeAra = lazy(() => import('./pages/Online/SozlesmeAra'));
const BayilikBasvurusuV2 = lazy(() => import('./pages/Online/BayilikBasvurusu'));
const TedarikciBasvurusuV2 = lazy(() => import('./pages/Online/TedarikciBasvurusu'));
const BayiAgi = lazy(() => import('./pages/Online/BayiAgi'));
const TedarikciAgimiz = lazy(() => import('./pages/Online/TedarikciAgimiz'));
const CekiciRouter = lazy(() => import('./pages/Online/CekiciRouter'));
const SanayiRouter = lazy(() => import('./pages/Online/SanayiRouter'));
const Paketler = lazy(() => import('./pages/Packages/Paketler'));
const PaketSatinalma = lazy(() => import('./pages/Packages/PaketSatinalma'));
const PaketMotosiklet = lazy(() => import('./pages/Packages/PaketMotosiklet'));
const PaketOtomobil = lazy(() => import('./pages/Packages/PaketOtomobil'));
const PaketHafifTicari = lazy(() => import('./pages/Packages/PaketHafifTicari'));
const PaketAgirTicari = lazy(() => import('./pages/Packages/PaketAgirTicari'));
const PaketIkame = lazy(() => import('./pages/Packages/PaketIkame'));
const PaketDetay = lazy(() => import('./pages/Packages/PaketDetay'));
const Hizmetler = lazy(() => import('./pages/Services/ServicesMain'));
const HizmetDetayPage = lazy(() => import('./pages/Services/ServiceDetail'));
const SehirHizmetPage = lazy(() => import('./pages/Services/SehirHizmetPage'));
const Blog = lazy(() => import('./pages/Blog/BlogList'));
const BlogDetailPage = lazy(() => import('./pages/Blog/BlogDetail'));
const YolYardims = lazy(() => import('./pages/SEO/Sehirler'));
const SehirDetay = lazy(() => import('./pages/SEO/SehirDetay'));

const PageFallback = () => (
  <div className="d-flex justify-content-center align-items-center min-vh-50 py-5">
    <div className="spinner-border text-primary" role="status" aria-label="Yükleniyor">
      <span className="visually-hidden">Yükleniyor...</span>
    </div>
  </div>
);

/**
 * Main App Component - Clean Structure
 * All routes wrapped with Layout for consistent header/footer
 */
function App() {
  return (
    <Suspense fallback={<PageFallback />}>
      <Routes>
        {/* Homepage */}
        <Route path="/" element={<Layout><Homepage /></Layout>} />
        <Route path="*" element={<Layout><Homepage /></Layout>} />

        {/* Corporate Pages */}
        <Route path="/tr/kurumsal/mobil-assistance-kurumsal" element={<Layout><KurumsalMain /></Layout>} />
      <Route path="/tr/kurumsal/mobil-assistance-hakkinda" element={<Layout><Kurumsal /></Layout>} />
      <Route path="/tr/kurumsal/kurumsal-hedefler" element={<Layout><Hedefler /></Layout>} />
      <Route path="/tr/kurumsal/kalite-politikamiz" element={<Layout><KalitePolitikasi /></Layout>} />
      <Route path="/tr/kurumsal/tarihcemiz" element={<Layout><Tarihce /></Layout>} />
      <Route path="/tr/kurumsal/etik-kurallarimiz" element={<Layout><Etik /></Layout>} />
      <Route path="/tr/kurumsal/tanitim-filmi" element={<Layout><TanitimFilmi /></Layout>} />
      <Route path="/tr/kurumsal/kalite-belgelerimiz" element={<Layout><Belgeler /></Layout>} />
      <Route path="/tr/kurumsal/kurumsal-kimlik" element={<Layout><KurumsalK /></Layout>} />

      {/* Other Pages */}
      <Route path="/tr/mobil-assistance/insan-kaynaklari" element={<Layout><InsanKaynaklari /></Layout>} />
      <Route path="/tr/mobil-assistance/iletisim" element={<Layout><Iletisim /></Layout>} />
      <Route path="/tr/mobil-assistance/sehirler" element={<Layout><YolYardims /></Layout>} />
      <Route path="/tr/mobil-assistance/yol-yardim" element={<Layout><SehirDetay /></Layout>} />

      {/* Online İşlemler */}
      <Route path="/tr/online-islemler" element={<Layout><OnlineMain /></Layout>} />
      <Route path="/tr/online-islemler/sozlesme-ara" element={<Layout><OnlineSozlesmeAra /></Layout>} />
      <Route path="/tr/online-islemler/bayilik-basvurusu" element={<Layout><BayilikBasvurusuV2 /></Layout>} />
      <Route path="/tr/online-islemler/tedarikci-basvurusu" element={<Layout><TedarikciBasvurusuV2 /></Layout>} />
      <Route path="/tr/online-islemler/bayi-agimiz" element={<Layout><BayiAgi /></Layout>} />
      <Route path="/tr/online-islemler/tedarikci-agimiz" element={<Layout><TedarikciAgimiz /></Layout>} />
      <Route path="/tr/online-islemler/paket-satinalma" element={<Layout><PaketSatinalma /></Layout>} />
      <Route path="/cekiciler/:detailSlug" element={<Layout><CekiciRouter /></Layout>} />
      <Route path="/sanayiler/:detailSlug" element={<Layout><SanayiRouter /></Layout>} />

      {/* Packages */}
      <Route path="/tr/paketler" element={<Layout><Paketler /></Layout>} />
      <Route path="/tr/paketler/:packageId" element={<Layout><PaketDetay /></Layout>} />
      <Route path="/tr/paket-satinalma/:packageId" element={<Layout><PaketSatinalma /></Layout>} />
      <Route path="/tr/paketler-motosiklet-yol-yardim-paketleri" element={<Layout><PaketMotosiklet /></Layout>} />
      <Route path="/tr/paketler-otomobil-yol-yardim-paketleri" element={<Layout><PaketOtomobil /></Layout>} />
      <Route path="/tr/paketler-hafif-ticari-yol-yardim-paketleri" element={<Layout><PaketHafifTicari /></Layout>} />
      <Route path="/tr/paketler-agir-ticari-yol-yardim-paketleri" element={<Layout><PaketAgirTicari /></Layout>} />
      <Route path="/tr/paketler-ikame-arac-yol-yardim-paketleri" element={<Layout><PaketIkame /></Layout>} />

      {/* Services */}
      <Route path="/tr/hizmetlerimiz" element={<Layout><Hizmetler /></Layout>} />
      <Route path="/tr/hizmetlerimiz/:category/:subCategory" element={<Layout><HizmetDetayPage /></Layout>} />
      <Route path="/tr/hizmetlerimiz/:category" element={<Layout><HizmetDetayPage /></Layout>} />

      {/* Blog */}
      <Route path="/tr/blog" element={<Layout><Blog /></Layout>} />
      <Route path="/tr/blog/:slug" element={<Layout><BlogDetailPage /></Layout>} />

      {/* City-based Services */}
      <Route path="/yol-yardim/:sehir" element={<Layout><SehirHizmetPage /></Layout>} />
      <Route path="/ikame-arac/:sehir" element={<Layout><SehirHizmetPage /></Layout>} />
      <Route path="/cagri-merkezi/:sehir" element={<Layout><SehirHizmetPage /></Layout>} />
      <Route path="/cekici-hizmeti/:sehir" element={<Layout><SehirHizmetPage /></Layout>} />
    </Routes>
    </Suspense>
  );
}

export default App;
